import axios from "axios";
import { PRESSKIT, PRESSKIT_LOADING } from "../constants/presskit";

import { API_URL } from "../config/config";
import { SOURCE } from "../constants/global";

export function fetchPresskit(locale) {
  return (dispatch) => {
    dispatch(presskitAreLoading(true));

    const config = { params: { source: SOURCE, locale: locale } };

    axios
      .get(`${API_URL}presskit`, config)
      .then((response) => {
        return response;
      })
      .then((response) => {
        dispatch(presskitSuccess(response.data.data));
        dispatch(presskitAreLoading(false));

        return response;
      })
      .catch((e) => console.log("error loading presskit", e));
  };
}

function presskitAreLoading(bool) {
  return {
    type: PRESSKIT_LOADING,
    bool,
  };
}

function presskitSuccess(data) {
  return {
    type: PRESSKIT,
    data,
  };
}
